import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import React from 'react';
import { keyframes, styled } from 'styled-components';

const bounceAnimation = keyframes`
  0% {
    top: 4px;
    animation-timing-function: ease-in;
  }

  50% {
    top: 10px;
    animation-timing-function: ease-out;
    width: 12px;
  }

  55% {
    top: 14px;
    animation-timing-function: ease-in;
    width: 13px;
    height: 12px;
  }

  65% {
    top: 6px;
    animation-timing-function: ease-out;
    width: 12px;
    height: 16px;
  }

  95% {
    top: 4px;
    animation-timing-function: ease-in;
  }

  100% {
    top: 4px;
    animation-timing-function: ease-in;
  }
`;
const Balls = styled.div.withConfig({
  displayName: "KLoadingBalls__Balls",
  componentId: "sc-1ky4slj-0"
})(["position:relative;display:inline-block;height:28px;width:80px;color:", ";span{position:absolute;top:4px;width:12px;height:12px;background:currentcolor;border-radius:50%;animation:", " 1s infinite;will-change:top,width,height;}span:nth-child(1){left:2px;}span:nth-child(2){left:24px;animation-delay:0.2s;}span:nth-child(3){left:46px;animation-delay:0.4s;}span:nth-child(4){left:66px;animation-delay:0.6s;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.k.color.kBrand.kOrange;
}, bounceAnimation);
function KLoadingBalls(props) {
  return /*#__PURE__*/React.createElement(Balls, _extends({
    "aria-live": "polite",
    "aria-busy": true
  }, props), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
}

export { KLoadingBalls };
